import { Trans } from '@lingui/react';
import { ListItemDecorator } from '@startuptools/ui/ListItemDecorator';
import { MenuItem } from '@startuptools/ui/MenuItem';
import { Divider } from '@startuptools/ui/Divider';

const EnFlag = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_721_11098)">
      <path
        d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
        fill="#F0F0F0"
      />
      <path
        d="M1.65159 3.62964C1.02319 4.44723 0.549344 5.38958 0.273438 6.41329H4.43525L1.65159 3.62964Z"
        fill="#0052B4"
      />
      <path
        d="M15.7242 6.41326C15.4483 5.38958 14.9745 4.44723 14.3461 3.62964L11.5625 6.41326H15.7242Z"
        fill="#0052B4"
      />
      <path
        d="M0.273438 10.5872C0.549375 11.6108 1.02322 12.5532 1.65159 13.3708L4.43516 10.5872H0.273438Z"
        fill="#0052B4"
      />
      <path
        d="M12.8696 2.15382C12.052 1.52542 11.1097 1.05157 10.0859 0.775635V4.93742L12.8696 2.15382Z"
        fill="#0052B4"
      />
      <path
        d="M3.12891 14.8463C3.9465 15.4747 4.88884 15.9486 5.91253 16.2245V12.0627L3.12891 14.8463Z"
        fill="#0052B4"
      />
      <path
        d="M5.9125 0.775635C4.88881 1.05157 3.94647 1.52542 3.12891 2.15379L5.9125 4.93738V0.775635Z"
        fill="#0052B4"
      />
      <path
        d="M10.0859 16.2245C11.1096 15.9486 12.052 15.4747 12.8695 14.8463L10.0859 12.0627V16.2245Z"
        fill="#0052B4"
      />
      <path
        d="M11.5625 10.5872L14.3461 13.3708C14.9745 12.5532 15.4483 11.6108 15.7242 10.5872H11.5625Z"
        fill="#0052B4"
      />
      <path
        d="M15.9323 7.45653H9.04353H9.0435V0.567719C8.70191 0.52325 8.35366 0.5 8 0.5C7.64628 0.5 7.29809 0.52325 6.95653 0.567719V7.45647V7.4565H0.0677188C0.02325 7.79809 0 8.14634 0 8.5C0 8.85372 0.02325 9.20191 0.0677188 9.54347H6.95647H6.9565V16.4323C7.29809 16.4768 7.64628 16.5 8 16.5C8.35366 16.5 8.70191 16.4768 9.04347 16.4323V9.54353V9.5435H15.9323C15.9768 9.20191 16 8.85372 16 8.5C16 8.14634 15.9768 7.79809 15.9323 7.45653Z"
        fill="#D80027"
      />
      <path
        d="M10.0859 10.5869L13.6558 14.1568C13.82 13.9927 13.9766 13.8211 14.1261 13.6432L11.0698 10.5869H10.0859V10.5869Z"
        fill="#D80027"
      />
      <path
        d="M5.91366 10.5869H5.91359L2.34375 14.1568C2.50787 14.3209 2.67947 14.4776 2.85734 14.627L5.91366 11.5706V10.5869Z"
        fill="#D80027"
      />
      <path
        d="M5.91512 6.41323V6.41317L2.34525 2.84326C2.18106 3.00739 2.02444 3.17898 1.875 3.35686L4.93134 6.4132H5.91512V6.41323Z"
        fill="#D80027"
      />
      <path
        d="M10.0859 6.41321L13.6558 2.84327C13.4917 2.67908 13.3201 2.52245 13.1423 2.37305L10.0859 5.42939V6.41321Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_721_11098">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const SvFlag = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_721_11132)">
      <path
        d="M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
        fill="#FFDA44"
      />
      <path
        d="M6.25784 7.45653H15.9292C15.4179 3.53131 12.0615 0.5 7.99694 0.5C7.39963 0.5 6.81778 0.566031 6.25781 0.690156V7.45653H6.25784Z"
        fill="#0052B4"
      />
      <path
        d="M4.17259 7.45644V1.47266C1.9759 2.67122 0.403375 4.86969 0.0664062 7.45647H4.17259V7.45644Z"
        fill="#0052B4"
      />
      <path
        d="M4.17256 9.54346H0.0664062C0.403375 12.1302 1.9759 14.3287 4.17259 15.5272L4.17256 9.54346Z"
        fill="#0052B4"
      />
      <path
        d="M6.25781 9.54349V16.3098C6.81778 16.434 7.39963 16.5 7.99694 16.5C12.0615 16.5 15.4179 13.4687 15.9292 9.54346H6.25781V9.54349Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_721_11132">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SwitchLangMenuItem = ({
  switchLang,
  lang,
}: {
  switchLang?: (lang: 'en' | 'sv') => void;
  lang: 'en' | 'sv';
}) => {
  return lang === 'sv' ? (
    <>
      <MenuItem onClick={switchLang ? () => switchLang('en') : undefined}>
        <ListItemDecorator>
          <EnFlag />
        </ListItemDecorator>
        <Trans id="Switch to English" />
      </MenuItem>
      <Divider />
    </>
  ) : (
    <>
      <MenuItem onClick={switchLang ? () => switchLang('sv') : undefined}>
        <ListItemDecorator>
          <SvFlag />
        </ListItemDecorator>
        <Trans id="Switch to Swedish" />
      </MenuItem>
      <Divider />
    </>
  );
};
